import React, { Fragment, useContext, useEffect } from "react";
import UserItem from "./UserItem";
import Spinner from "../layout/Spinner";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import UserContext from "../../context/user/userContext";

const Users = () => {
  const userContext = useContext(UserContext);

  const { users, filtered, getUsers, loading } = userContext;

  useEffect(() => {
    getUsers();
    // eslint-disable-next-line
  }, []);

  if (users !== null && users.length === 0 && !loading) {
    return <h4>Please enter a user</h4>;
  }

  return (
    <Fragment>
      <div style={{ height: "90vh", overflow: "auto" }}>
        {users !== null && !loading ? (
          <TransitionGroup>
            {filtered !== null
              ? filtered.map(user => (
                  <CSSTransition key={user.id} timeout={500} classNames="item">
                    <UserItem user={user} />
                  </CSSTransition>
                ))
              : users.map(user => (
                  <CSSTransition key={user.id} timeout={500} classNames="item">
                    <UserItem user={user} />
                  </CSSTransition>
                ))}
          </TransitionGroup>
        ) : (
          <Spinner />
        )}
      </div>
    </Fragment>
  );
};

export default Users;
